export default "/backend/static/media/yellow.717adb29.png";